/**
 * Created by luis on 9/4/16.
 */
//define actions responses for users' interactions
//to handle click
(function(){ 
    console.log('from wplx actions.js');
    function doAction(actionObject)
    {

    }

    //handle action on element click
    /**
     * The key to handle click is this. The elementsActions object registered the action for
     * landing page -> container element (.c37-item-element). When then c37-child is clicked, it will
     * find in the elementsAction the object has the name by .c37-item-element ID
     * Illustration can be found here: https://drive.google.com/open?id=0B1dTAFXQBPD2b29oWWFYa0dKQW8
     */
    jQuery(document).on('click', '.c37-lp .c37-lp-element', function(){
        if (typeof elementsActions === 'undefined')
        {
            console.log(' action object is nulled; ');
            return;
        }

        console.log(' action object is NOTE null ');

        var pageUUID = jQuery(this).closest('.c37-page-wrapper').attr('data-c37-uuid');

        //parentID is the ID of the container (which has the class .c37-lp-element)
        var parentID = jQuery(this).closest('.c37-lp-element').attr('id');

        console.log('parent element: ', parentID);

        //elementActions is the global object that contains all Actions of all pages (for cases when there are multiple
        //pages/widget/popup available in one URL)
        var pageElementOptions = elementsActions[pageUUID];

        if (!_.isEmpty(pageElementOptions))
        {
            //should have used a temporary ID for this
            var elementAction = pageElementOptions[parentID];

            if (typeof elementAction !== "object")
            {
                console.log('element action is nulled');
                return;
            }

            _.each(elementAction, function(singleAction){
                if (singleAction.action === 'open-link')
                {
                    console.log('open link');
                    if (singleAction['new-tab'])
                    {
                        window.open(singleAction.target);
                    } else
                    {
                        window.location.href = singleAction.target;
                    }

                } else if (singleAction.action === 'submit-form')
                {
                    /*
                     | Submit current form
                     */
                    jQuery(this).closest('form').submit();

                } else if (singleAction.action === 'open-popup')
                {

                    console.log('open popup again' );
                    /**
                     * c37PopupTrigger is an object set in c37-popup-manager.php
                     *
                     */
                    if (typeof c37PopupTrigger !== 'undefined')
                    {
                        //need to add tracking here for popup open and close

                        var id = '#'+c37PopupTrigger[singleAction['element-id']];
                        console.log('open the popup with ID: ', id);
                        jQuery(id).removeClass('c37-d-none');
                        jQuery(id).show();

                    } else
                    {
                        console.log('c37 popup trigger is undefined')
                    }
                } else if(singleAction.action === 'close-popup')
                {
                    //close the popup
                    console.log('id is: ', '#' + singleAction['element-id']);
                    jQuery('#' + singleAction['element-id']).closest('.c37-lp-popup-outer').remove();
                } else if (singleAction.action === 'show-elements')
                {
                    var elementsToShow = singleAction.target;
                    jQuery(elementsToShow).removeClass('c37-d-none');


                } else if (singleAction.action === 'hide-elements')
                {
                    var elementsToHide = singleAction.target;
                    jQuery(elementsToHide).addClass('c37-d-none');
                }
            });


        }



    });
})();

